<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      :raw-data="players"
      :chart-value-keys="chartValueKeys"
      x-value="last_name"
      y-value-prefix="latest_stats."
      :yaxis="yAxisConfig"
      :xaxis="xAxisConfig"
      :colors="['#26E18E', '#F62424']"
    >
      <template v-slot:header>
        <v-card-title class="pa-4">
          <v-row
            no-gutters
            align="center"
          >
            <v-col>
              <div
                class="subtitle-2 grey--text text--grey-100"
                style="word-break: normal"
              >
                {{ $t('card_title.mood_stress') }}
              </div>
            </v-col>
            <v-col
              cols="auto"
              class="ml-3"
            >
              <v-btn
                v-if="removable"
                icon
                style="pointer-events: auto"
                @click="$emit('remove')"
              >
                <v-icon small>
                  fal fa-times
                </v-icon>
              </v-btn>
              <visual-list-toggle
                v-else
                :value.sync="viewMode"
              />
            </v-col>
          </v-row>
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-4">
        <v-row
          no-gutters
          align="center"
        >
          <v-col>
            <div
              class="subtitle-2 grey--text text--grey-100"
              style="word-break: normal"
            >
              {{ $t('card_title.mood_stress') }}
            </div>
          </v-col>
          <v-col
            cols="auto"
            class="ml-3"
          >
            <visual-list-toggle
              v-if="!removable"
              :value.sync="viewMode"
            />
          </v-col>
        </v-row>
      </v-card-title>

      <chart-list-view-table
        :headers="tableHeaders"
        :items="players"
      >
        <template v-slot:item.last_name="{ item }">
          {{ item.last_name }}, {{ item.first_name }}
        </template>
      </chart-list-view-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'
import ChartListViewTable from '@/components/charts/implementation/ChartListViewTable.vue'

export default {
  name: 'MoodStressChart',
  components: { ChartListViewTable, LineChart, VisualListToggle },
  props: {
    players: {
      type: Array,
      required: true,
      default: () => []
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    chartValueKeys() {
      return [
        {
          key: 'MOO',
          label: this.$t('variables.MOO.long'),
          type: 'bar'
        },
        {
          key: 'STL',
          label: this.$t('variables.STL.long'),
          type: 'bar'
        }
      ]
    },
    yAxisConfig() {
      return [
        {
          title: { text: this.$t('variables.MOO.long') },
          min: 0,
          max: 5
        },
        {
          title: { text: this.$t('variables.STL.long') },
          min: 0,
          max: 5,
          opposite: true
        }
      ]
    },
    xAxisConfig() {
      return {
        labels: {
          rotate: -45
        },
        categories: this.players.map(p => p.first_name[0] + '. ' + p.last_name),
        tickPlacement: 'between'
      }
    },
    tableHeaders() {
      return [
        {
          text: this.$t('table_headers.name'),
          value: 'last_name',
          sortable: true,
          width: '20%'
        },
        {
          text: this.$t('variables.MOO.long'),
          value: 'latest_stats.MOO',
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('variables.STL.long'),
          value: 'latest_stats.STL',
          sortable: true,
          align: 'center'
        }
      ]
    }
  }
}
</script>
